<ng-container [ngSwitch]="data.desktopTemplate">
    <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="mobile"></ng-container>
    <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="mobile"></ng-container>
    <ng-container *ngSwitchDefault [ngTemplateOutlet]="desk"></ng-container>
</ng-container>


<ng-template #mobile>
    <div class="wrp">
        <div class="cc14">
            <span multilang class="cc1-mb">Preise für diese Suche beobachten</span>
            <button (click)="onClose()">
                <mat-icon class="cc15" fontIcon="close"></mat-icon>
            </button>
        </div>

        <div class="cc2-mb">
            <input type="email" class="cc4-mb" [class.errorem]="error" [(ngModel)]="myEmail"
                placeholder="E-Mail-Adresse *">
            <ng-container *ngIf="error">
                <mat-hint class="errr">* E-Mail-Adresse Pflichtfeld</mat-hint>
            </ng-container>
            <button (click)="activePrc()" class="cc5-mb">Preisalarm aktivieren</button>
        </div>

        <ng-container *ngTemplateOutlet="emailacc"></ng-container>

        <div class="cc3-mb">
            @if(data?.image?.length > 0) {
            <img class="lazyload ccimg-mb" data-src="{{data?.image | cacheResource}}" alt="{{data?.hotel?.name}}">
            }
            <div class="cc7-mb">
                <div class="cc17-mb">
                    <span multilang class="chname">{{data?.hotel?.name}}</span>
                    <div class="startdiv-mb">
                        <mat-icon *ngFor="let cat of data?.categoryAr;">
                            {{cat === 1 ? 'star': 'star_half'}}
                        </mat-icon>
                    </div>
                </div>
                <span multilang class="cc8-mb">Ihr Preisalarm Beinhaltet folgende Kriterien</span>
                <ng-container *ngTemplateOutlet="flst"></ng-container>
                <clever-preisealarmselectedfilters [filter]="data?.filter"></clever-preisealarmselectedfilters>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #emailacc>
    <div class="cc6">
        <span multilang>Bei Preisänderungen senden wir Ihnen eine E-Mail</span>
        <button class="mt5 cc9" (click)="showCustomPrs = !showCustomPrs;">
            <mat-icon class="checkico" *ngIf="!showCustomPrs" fontIcon="check_circle"></mat-icon>
            <mat-icon class="checkico" *ngIf="showCustomPrs" fontIcon="radio_button_unchecked"></mat-icon>
            <span multilang>Preisänderungen</span>
        </button>
        <button class="cc9" (click)="showCustomPrs = !showCustomPrs;">
            <mat-icon class="checkico" *ngIf="showCustomPrs" fontIcon="check_circle"></mat-icon>
            <mat-icon class="checkico" *ngIf="!showCustomPrs" fontIcon="radio_button_unchecked"></mat-icon>
            <span multilang>Wunschpreis selbst wählen</span>
        </button>
        <ng-container *ngIf="showCustomPrs">
            <div class="cc10">
                <div class="cc11">
                    <div class="cc11-b">
                        <span multilang class="cc13">min</span>
                        <input [(ngModel)]="minprc" [class.errorem]="errorpr" class="cc12" type="number">
                    </div>
                    <span multilang class="cc13-hint">* erst bei erreichen des Mindestpreises benachrichtigen</span>
                </div>
                <div class="cc11">
                    <div class="cc11-b">
                        <span multilang class="cc13">max</span>
                        <input [(ngModel)]="maxprc" [class.errorem]="errorpr" class="cc12" type="number">
                    </div>
                    <span multilang class="cc13-hint">* erst bei erreichen des Höchstpreises benachrichtigen</span>
                </div>
            </div>
        </ng-container>
    </div>
</ng-template>

<ng-template #desk>
    <div class="wrp">
        <div class="cc14">
            <span multilang class="cc1">Preise für diese Suche beobachten</span>
            <button (click)="onClose()">
                <mat-icon class="cc15" fontIcon="close"></mat-icon>
            </button>
        </div>

        <div class="cc2">
            <input type="email" class="cc4" [class.errorem]="error" [(ngModel)]="myEmail"
                placeholder="E-Mail-Adresse *">
            <button (click)="activePrc()" class="cc5">Preisalarm aktivieren</button>
        </div>
        <ng-container *ngIf="error">
            <mat-hint class="errr">* E-Mail-Adresse Pflichtfeld</mat-hint>
        </ng-container>

        <ng-container *ngTemplateOutlet="emailacc"></ng-container>

        <div class="cc3">
            <img class="lazyload ccimg" *ngIf="data?.image?.length > 0" data-src="{{data?.image | cacheResource}}"
                alt="{{data?.hotel?.name}}">
            <div class="cc7">
                <span multilang class="cc8">Ihr Preisalarm Beinhaltet folgende Kriterien</span>

                <div class="cc17">
                    <span multilang class="chname">{{data?.hotel?.name}}</span>
                    <div class="startdiv">
                        <mat-icon *ngFor="let cat of data?.categoryAr;">
                            {{cat === 1 ? 'star': 'star_half'}}
                        </mat-icon>
                    </div>
                </div>

                <ng-container *ngTemplateOutlet="flst"></ng-container>
                <clever-preisealarmselectedfilters [filter]="data?.filter"></clever-preisealarmselectedfilters>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #flst>
    <ng-container *ngIf="data?.filter?.productType === 'pauschal'">
        <ng-container *ngIf="!(data?.filter?.airportsResult?.length > 0) else airlist">
            <div class="mt1 cc20">
                <mat-icon class="cc19" fontIcon="flight"></mat-icon>
                <span multilang class="ml5">Abflughafen - alle Flughäfen</span>
            </div>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="data?.filter?.productType === 'railtravel'">
        <ng-container *ngIf="!(data?.filter?.airportsResult?.length > 0) else banlist">
            <div class="mt1 cc20">
                <mat-icon class="cc19" fontIcon="train"></mat-icon>
                <span multilang class="ml5">Ab Bahnhof - alle Banhöfe</span>
            </div>
        </ng-container>
    </ng-container>
    <div class="mt3 cc20">
        <mat-icon class="cc19" fontIcon="calendar_month"></mat-icon>
        <span multilang class="ml5">
            {{data?.filter?.reisedauerResult?.name}} zwischen {{data?.filter?.reisezeitraumResult?.start |
            date:'dd.MM.yyyy'}} und {{data?.filter?.reisezeitraumResult?.end | date:'dd.MM.yyyy'}}
        </span>
    </div>
    <div class="mt3 cc20">
        <mat-icon class="cc19" fontIcon="people"></mat-icon>
        <span multilang class="ml5">
            {{data?.filter?.reisendeResult?.adults}} Erw. {{data?.filter?.reisendeResult?.children?.length >
            0
            ?
            data.filter.reisendeResult.children.length + (data.filter.reisendeResult.children.length === 1 ?
            ' Kind':
            ' Kinder') : ''}}
        </span>
    </div>
</ng-template>

<ng-template #airlist>
    <div class="cc18">
        <div class="cc20">
            <mat-icon class="cc19" fontIcon="flight"></mat-icon>
            <span multilang class="ml5">Abflughafen:</span>
        </div>
        <ng-container *ngFor="let air of data?.filter?.airportsResult;let k=index">
            <span multilang> {{air.name}} ({{air.code}}){{k !== data?.filter?.airportsResult?.length - 1 ? ',':
                ''}}</span>
        </ng-container>
    </div>
</ng-template>

<ng-template #banlist>
    <div class="mt1 cc18">
        <div class="cc20">
            <mat-icon class="cc19" fontIcon="train"></mat-icon>
            <span multilang class="ml5">Ab Bahnhof :</span>
        </div>
        <ng-container *ngFor="let air of data?.filter?.airportsResult;let k=index">
            <span multilang> {{air.name}} ({{air.code}}){{k !== data?.filter?.airportsResult?.length - 1 ? ',':
                ''}}</span>
        </ng-container>
    </div>
</ng-template>